import i18n from "@/libs/i18n/i18n";
import educationalDegrees from "@/constatnts/educationalDegrees";
export const initialState = {
  genders: [
    { value: "female", text: i18n.t("general.female") },
    { value: "male", text: i18n.t("general.male") },
  ],
  addressTypes: [
    { value: "home", text: i18n.t("address.home") },
    { value: "work", text: i18n.t("address.work") },
  ],
  addressCities: [],
  maritalStatuses: [
    { value: "married", text: i18n.t("user.married") },
    { value: "single", text: i18n.t("user.single") },
  ],
  // educationalDegrees: educationalDegrees ,
  roles: [],
  users: [],
  role: [],
  unit: [],
  units: [],
  firstName: "",
  lastName: "",
  username: "",
  medicalSpecialtyId: "",
  medicalScientificDegreeId: "",
  bankId: "",
  password: "",
  confirm: "",
  mobile: "",
  mobileCountryId: "",
  // spouseFirstName: '',
  // spouseLastName: '',
  // spouseNationalCode:'',
  // spouseIdentityCode:'',
  // spouseCountryId: '',
  fatherName: "",
  nationalCode: "",
  otherCode: "",
  expiryDateOfIdentityDocument: null,
  typeOfIdentificationDocument: null,
  typeOfIdentificationDocuments: [
    { text: "passport", _id: "PASSPORT" },
    { text: "biography", _id: "BIOGRAPHY" },
    {
      text: "citizen_identification_document",
      _id: "CITIZEN_IDENTIFICATION_DOCUMENT",
    },
    { text: "rental", _id: "RENTAL" },
    { text: "contract_booklet", _id: "CONTRACT_BOOKLET" },
    // {text:'other', value:'OTHER'},
  ],
  forefatherName: null,
  dateOfBirth: "",
  mobiles: [{ mobile: "", countryId: "" }],
  email: "",
  country: "",
  province: "",
  city: "",
  gender: "male",
  roleFilter: null,
  birthCity: "",
  birthProvince: "",
  placeOfBirthCityForForeign: "",
  maritalStatus: "",
  referralWays: "",
  referralWay: "",
  socialNetworks: [],
  referrerName: "",
  referrerUser: "",
  referrerUsers: [],
  referrerAddress: "",
  referrerNationalCode: "",
  spouses: [
    {
      relationshipId: {
        _id: null,
        dateOfMarriage: '',
      },
      spouseId: {
        // relationshipId: null,
        _id: null,
        countryId: '',
        firstName: '',
        lastName: '',
        fatherName: '',
        nationalCode: '',
        identityCode: '',
        dateOfBirth: '',
        educationalDegree: '',
        job: '',
      },
      isDeleted: false
    },
  ],
  spousesToDelete: [],
  phones: [{ phone: "", internal: "", type: "", countryId: "" }],
  // issuedCountry: '',
  addresses: [
    {
      cityId: "",
      address: "",
      type: "",
      countryId: "",
    },
  ],
  userToEdit: null,
  userServiceEdit: "",
  userAddService: "",
  serviceToAdd: "",
  usersToAdd: [
    {
      userId: "",
      userShare: "",
      userTax: "",
      hospitalShare: "",
      hospitalTax: "",
    },
  ],
  usersToAddIndex: null,
  foreignUserToSearch: {
    firstName: "",
    lastName: "",
    dateOfBirth: null,
    fatherName: "",
    countryId: null,
  },
  searchedForeigners: [],
  userProfile: null,
  birthCertificateId: null,
  medicalSystemNumber: "",
  startDateAtWork: "",
  endDateAtWork: "",
  completionDateOfMedicalLicense: "",
  officeLicenseNumber: "",
  facultyStatus: "full_time",
  statusOfMemberships: [
    { value: "non_full_time", text: i18n.t("user.nonFullTime") },
    {
      value: "full_time_geographical",
      text: i18n.t("user.fullTimeGeographical"),
    },
    { value: "full_time", text: i18n.t("user.fullTime") },
  ],
  accountNumber: "",
  iBAN: "",
  accountType: "",
  cooperationType: "guest",
  companyTypes: [
    { value: "guest", text: i18n.t("user.guest") },
    { value: "formal", text: i18n.t("user.formal") },
  ],
  description: "",
  dateOfGraduation: null,
  fieldOfStudy: "",
  educationalDegree: null,
  job: "",
  educationalDegreeTypes: [
    { value: "illiterate", text: i18n.t("educationalDegree.illiterate") },
    {
      value: "primary_school",
      text: i18n.t("educationalDegree.primarySchool"),
    },
    { value: "middle_school", text: i18n.t("educationalDegree.middleSchool") },
    { value: "diploma", text: i18n.t("educationalDegree.diploma") },
    { value: "associate", text: i18n.t("educationalDegree.associate") },
    { value: "bachelor", text: i18n.t("educationalDegree.bachelor") },
    { value: "master", text: i18n.t("educationalDegree.master") },
    { value: "doctoral", text: i18n.t("educationalDegree.doctoral") },
    { value: "post_doctoral", text: i18n.t("educationalDegree.postDoctoral") },
  ],
  citizenIdentificationDocument: [],
  allFiles: [],
  filesList: [],
  editedFiles: [],
  removalFiles: [],
  addedFiles: [],
  attachedPayload: [],
  total: "",
  legalFileNumber: "",
  insuranceNumber: "",
  userNational: [
    { value: "both", text: i18n.t("user.both") },
    { value: "iranian", text: i18n.t("user.iranian") },
    { value: "foreign", text: i18n.t("user.foreign") },
  ],
};
